export const VEHICLE_IMAGE_REFETCH_INTERVAL_MS = 60 * 1000
export const VEHICLE_IMAGE_THUMBNAIL_REFETCH_INTERVAL_MS = 30 * 1000 // 30 seconds
export const VEHICLE_IMAGE_STALE_TIME_MS = 0

export const VEHICLE_REFETCH_INTERVAL_MS = 5000

export const VEHICLE_DATA_SYNC_STALE_TIME_MS = 5000
export const VEHICLE_DATA_SYNC_REFETCH_INTERVAL_MS = 2000
export const VEHICLE_NAVIGATION_STALE_TIME_MS = 2000

export const AUTO_REFRESH_INTERVAL_MS = 15 * 60 * 1000 // 15 minutes

export const VEHICLE_PING_REFETCH_INTERVAL_MS = 15 * 1000 // 10 seconds

export const NAVIGATION_REFETCH_INTERVAL_MS = 200

export const DISPLAYABLE_EVENTS_REFETCH_INTERVAL_MS = 5000 // 5 seconds

export const SYNC_REFETCH_INTERVAL_MS = 1000

export const VEHICLE_HEALTH_BATTERY_REFETCH_INTERVAL_MS = 20 * 1000 // 20 seconds

export const VEHICLE_HEALTH_STATUS_REFETCH_INTERVAL_MS = 5000 // 5 seconds

export const HOTLINE_NUMBER = '+420 910 920 598'

export const HARDWARE_OTHER_PANEL_REFETCH_INTERVAL_MS = 20 * 1000 // 20 seconds

export const DIAGNOSTICS_SYSTEM_OVERVIEW_REFETCH_INTERVAL_MS = 120 * 1000 // 120 seconds

export const DIAGNOSTICS_LOGS_REFETCH_INTERVAL_MS = 60 * 1000 // 60 seconds

export const DIAGNOSTICS_LOG_DOWNLOAD_SIZE_MB = 20

// Matches log.file_size of the control unit (car/deployment/resources/group_vars/cu_hosts.yaml)
export const DIAGNOSTICS_CU_LOG_DOWNLOAD_SIZE_MB = 10

export const LOCAL_NAVIGATION_API = 'http://192.168.129.20:30303'

export const LOCAL_CONTROL_UNIT_API = 'https://192.168.129.21:40404'

export const CAR_SERVER_UNREACHABLE_ALERT_MINUTES = 10

export const MAPBOX_PUBLIC_TOKEN: string | undefined =
  import.meta.env.VITE_MAPBOX_PUBLIC_TOKEN ||
  (typeof window !== 'undefined' ? window.ENV?.MAPBOX_PUBLIC_TOKEN : undefined)

export const DISPLAY_DETECTIONS =
  import.meta.env.VITE_DISPLAY_DETECTIONS === 'true' ||
  (typeof window !== 'undefined' ? window.ENV?.DISPLAY_DETECTIONS === 'true' : false)

export const DISPLAY_SIGN_POSTS =
  import.meta.env.VITE_DISPLAY_SIGN_POSTS === 'true' ||
  (typeof window !== 'undefined' ? window.ENV?.DISPLAY_SIGN_POSTS === 'true' : false)

export const MAP_SNAPSHOTS_ENABLED =
  import.meta.env.VITE_MAP_SNAPSHOTS_ENABLED === 'true' ||
  (typeof window !== 'undefined' ? window.ENV?.MAP_SNAPSHOTS_ENABLED === 'true' : false)

export const DISPLAY_ANNEXATIONS =
  import.meta.env.VITE_DISPLAY_ANNEXATIONS === 'true' ||
  (typeof window !== 'undefined' ? window.ENV?.DISPLAY_ANNEXATIONS === 'true' : false)

export const DISPLAY_VEHICLE_HEALTH =
  import.meta.env.VITE_DISPLAY_VEHICLE_HEALTH === 'true' ||
  (typeof window !== 'undefined' ? window.ENV?.DISPLAY_VEHICLE_HEALTH === 'true' : false)

export const AUTO_SCHEDULE_REQUIREMENTS =
  import.meta.env.VITE_AUTO_SCHEDULE_REQUIREMENTS === 'true' ||
  (typeof window !== 'undefined' ? window.ENV?.AUTO_SCHEDULE_REQUIREMENTS === 'true' : false)

export const AUTO_SCHEDULE_DISTRICTS =
  import.meta.env.VITE_AUTO_SCHEDULE_DISTRICTS === 'true' ||
  (typeof window !== 'undefined' ? window.ENV?.AUTO_SCHEDULE_DISTRICTS === 'true' : false)

export const AUTO_SCHEDULE_COPY =
  import.meta.env.VITE_AUTO_SCHEDULE_COPY === 'true' ||
  (typeof window !== 'undefined' ? window.ENV?.AUTO_SCHEDULE_COPY === 'true' : false)

// On unless explicitly 'false': entrypoint.sh replaces an unset optional variable with an empty string.
export const isEnabledByDefault = (viteValue: string | undefined, runtimeValue: string | undefined): boolean =>
  viteValue !== 'false' && runtimeValue !== 'false'

export const COMPUTE_SSDR_ENABLED = isEnabledByDefault(
  import.meta.env.VITE_COMPUTE_SSDR_ENABLED,
  typeof window !== 'undefined' ? window.ENV?.COMPUTE_SSDR_ENABLED : undefined
)
